<template>
  <el-dialog v-if="isShow" :title="titleText" :visible="isShow" width="1000px" @close="handleCancel">
    <div class="advanceMakeDeatail">
      <el-form class="baseInfoForm">
        <div class="rj-row">
          <div class="rj-col-2">
            <div class="rj-baseinfo">
              <div class="rj-baseinfo__label">
                订单编号：
              </div>
              <div class="rj-baseinfo__item">
                {{ fromInfo.orderNum }}
              </div>
            </div>
          </div>
          <div class="rj-col-2">
            <div class="rj-baseinfo">
              <div class="rj-baseinfo__label">
                <i style="color: red">*</i>
                金税发票类型：
              </div>
              <div class="rj-baseinfo__item">
                <el-select v-model="fromInfo.invoiceType" placeholder="请选择">
                  <el-option
                    v-for="item in invoiceTypeData"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                    :disabled="item.disabled"
                  />
                </el-select>
              </div>
            </div>
          </div>
        </div>

        <div class="rj-row">
          <div class="rj-col-2">
            <div class="rj-baseinfo">
              <div class="rj-baseinfo__label">
                <i style="color: red">*</i>
                发票标记：
              </div>
              <div class="rj-baseinfo__item">
                <el-select v-model="fromInfo.invoiceMark" placeholder="请选择">
                  <el-option
                    v-for="item in invoiceMarkData"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                    :disabled="item.disabled"
                  />
                </el-select>
              </div>
            </div>
          </div>
          <div class="rj-col-2">
            <div class="rj-baseinfo">
              <div class="rj-baseinfo__label">
                订单客户编号：
              </div>
              <div class="rj-baseinfo__item">
                {{ fromInfo.orderUnitCode }}
              </div>
            </div>
          </div>
        </div>

        <div class="rj-row">
          <div class="rj-col-2">
            <div class="rj-baseinfo">
              <div class="rj-baseinfo__label">
                订单客户名称：
              </div>
              <div class="rj-baseinfo__item">
                {{ fromInfo.orderUnit }}
              </div>
            </div>
          </div>
          <div class="rj-col-2">
            <div class="rj-baseinfo">
              <div class="rj-baseinfo__label">
                税率：
              </div>
              <div class="rj-baseinfo__item">
                {{ fromInfo.taxRate }}%
              </div>
            </div>
          </div>
        </div>

        <div class="rj-row">
          <div class="rj-col-2">
            <div class="rj-baseinfo">
              <div class="rj-baseinfo__label">
                开票客户编号：
              </div>
              <div class="rj-baseinfo__item">
                {{ fromInfo.bankInfo && fromInfo.bankInfo.kpOrderUnitCode }}
              </div>
            </div>
          </div>
          <div class="rj-col-2">
            <div class="rj-baseinfo">
              <div class="rj-baseinfo__label">
                开票客户名称：
              </div>
              <div class="rj-baseinfo__item">
                <el-select
                  v-model="fromInfo.kpOrderUnitTemp"
                  filterable
                  placeholder="请选择"
                  :filter-method="getSelectClient"
                  @change="handleChange"
                >
                  <el-option
                    v-for="item in kpOrderUnitList"
                    :key="item.kpOrderUnit"
                    :label="item.kpOrderUnit"
                    :value="item.kpOrderUnit"
                  />
                </el-select>
              </div>
            </div>
          </div>
        </div>

        <div class="rj-row">
          <div class="rj-col-2">
            <div class="rj-baseinfo">
              <div class="rj-baseinfo__label">
                开票纳税人识别号：
              </div>
              <div class="rj-baseinfo__item">
                {{ fromInfo.bankInfo && fromInfo.bankInfo.kpTaxpayerNum }}
              </div>
            </div>
          </div>
          <div class="rj-col-2">
            <div class="rj-baseinfo">
              <div class="rj-baseinfo__label">
                纳税登记地址：
              </div>
              <div class="rj-baseinfo__item">
                {{ fromInfo.bankInfo && fromInfo.bankInfo.taxRegistrationAddress }}
              </div>
            </div>
          </div>
        </div>

        <div class="rj-row">
          <div class="rj-col-2">
            <div class="rj-baseinfo">
              <div class="rj-baseinfo__label">
                税务登记电话：
              </div>
              <div class="rj-baseinfo__item">
                {{ fromInfo.bankInfo && fromInfo.bankInfo.taxRegistrationTelephone }}
              </div>
            </div>
          </div>
          <div class="rj-col-2">
            <div class="rj-baseinfo">
              <div class="rj-baseinfo__label">
                开户行：
              </div>
              <div class="rj-baseinfo__item">
                {{ fromInfo.bankInfo && fromInfo.bankInfo.bankDeposit }}
              </div>
            </div>
          </div>
        </div>

        <div class="rj-row">
          <div class="rj-col-2">
            <div class="rj-baseinfo">
              <div class="rj-baseinfo__label">
                银行账号：
              </div>
              <div class="rj-baseinfo__item">
                {{ fromInfo.bankInfo && fromInfo.bankInfo.bankAccount }}
              </div>
            </div>
          </div>
          <div class="rj-col-2">
            <div class="rj-baseinfo">
              <div class="rj-baseinfo__label">
                收函人：
              </div>
              <div class="rj-baseinfo__item">
                <el-input v-model="fromInfo.bankInfo.receiveUser" placeholder="收函人" />
              </div>
            </div>
          </div>
        </div>

        <div class="rj-row">
          <div class="rj-col-2">
            <div class="rj-baseinfo">
              <div class="rj-baseinfo__label">
                收函人电话：
              </div>
              <div class="rj-baseinfo__item">
                <el-input v-model="fromInfo.bankInfo.receiveTelephone" placeholder="收函人电话" />
              </div>
            </div>
          </div>
          <div class="rj-col-2">
            <div class="rj-baseinfo">
              <div class="rj-baseinfo__label">
                收函单位：
              </div>
              <div class="rj-baseinfo__item">
                <el-input v-model="fromInfo.bankInfo.receiveCompany" placeholder="收函单位" />
              </div>
            </div>
          </div>
        </div>

        <div class="rj-row">
          <div class="rj-col-2">
            <div class="rj-baseinfo">
              <div class="rj-baseinfo__label">
                收函地址：
              </div>
              <div class="rj-baseinfo__item">
                <el-input v-model="fromInfo.bankInfo.receiveAddress" placeholder="收函地址" />
              </div>
            </div>
          </div>
          <div class="rj-col-2">
            <div class="rj-baseinfo">
              <div class="rj-baseinfo__label">
                开票备注：
              </div>
              <div class="rj-baseinfo__item">
                <el-input v-model="fromInfo.remark" placeholder="开票备注" />
              </div>
            </div>
          </div>
        </div>

        <div class="rj-row">
          <div class="rj-col-2">
            <div class="rj-baseinfo">
              <div class="rj-baseinfo__label">
                <i v-if="fromInfo.invoiceType === 2" style="color: red">*</i>
                发票接收邮箱：
              </div>
              <div class="rj-baseinfo__item">
                <el-input v-model="fromInfo.invoiceEmail" placeholder="发票接收邮箱" />
              </div>
            </div>
          </div>
          <div class="rj-col-2">
            <div class="rj-baseinfo">
              <div class="rj-baseinfo__label">
                <i style="color: red">*</i>
                开票总金额：
              </div>
              <div class="rj-baseinfo__item">
                <el-input v-model="fromInfo.invoiceAmount" placeholder="开票总金额" />
              </div>
            </div>
          </div>
        </div>

        <div class="rj-row">
          <div class="rj-col-2">
            <div class="rj-baseinfo">
              <div class="rj-baseinfo__label">
                是否整单开票：
              </div>
              <div class="rj-baseinfo__item">
                {{ fromInfo.isAllInvoice ? '是' : '否' }}
              </div>
            </div>
          </div>
          <div class="rj-col-2">
            <div class="rj-baseinfo flex-none">
              <div class="rj-baseinfo__label">
                附件上传：
              </div>
              <div class="rj-baseinfo__item file-item">
                <el-upload
                  action=""
                  multiple
                  show-file-list
                  name="fileName"
                  style="margin: 8px 10px 0 10px"
                  :http-request="uploadaction"
                  :file-list="fromInfo.fileListTemp"
                  :before-upload="handleProgress"
                  :on-remove="handleRemove"
                >
                  <div class="file-style">
                    <el-button type="primary">
                      上传附件
                    </el-button>
                  </div>
                </el-upload>
                <div class="down-file-style">
                  <el-button type="text" @click="$refs.file.click()">
                    下载模板
                  </el-button>
                  <a ref="file" href="/表格开票模板（财务）.xlsx" target="_blank" />
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="rj-row info-list">
          <div class="rj-col-1">
            <div class="rj-baseinfo">
              <div class="rj-baseinfo__label">
                产品信息
              </div>
              <el-button style="margin-left: 10px" type="primary" @click="handleExportProductInfo">
                导出当前开票产品信息
              </el-button>
            </div>
          </div>
        </div>

        <el-table
          :data="fromInfo.productList"
          :summary-method="handleTotal"
          border
          show-summary
          style="width: 100%"
          sum-text="合计"
        >
          <el-table-column type="index" label="序号" width="50px" align="left" fixed="left" />
          <el-table-column prop="productCode" label="销售产品代码" width="100px" align="left" />
          <el-table-column prop="productName" label="销售产品名称" width="100px" align="left" fixed="left" />
          <el-table-column prop="productNum" label="数量" align="left" />
          <el-table-column prop="settlementUnitPrice" label="实际结算单价" width="100px" align="right" header-align="left" />
          <el-table-column prop="settlementAmount" label="实际结算金额" width="100px" align="right" header-align="left" />
          <el-table-column prop="amountExcludingTax" label="不含税金额" width="100px" align="right" header-align="left" />
          <el-table-column prop="taxAmount" label="税额" align="right" header-align="left" />
          <el-table-column prop="expectedDeliveryDate" label="客户期望发货日" width="180px" align="left" />
          <el-table-column prop="agreedDeliveryDate" label="约定交付日期" width="180px" align="left" />
          <el-table-column prop="taxRate" label="税率" align="right" header-align="left">
            <template v-slot="{row}">
              <span>{{ row.taxRate ? `${row.taxRate}%` : '' }}</span>
            </template>
          </el-table-column>
        </el-table>

        <div v-if="viewType === 'edit'">
          <div style="padding:10px 0">
            历史审批意见：
          </div>
          <el-table :data="fromInfo.approvalList" border style="width: 100%">
            <el-table-column prop="userName" label="审批人" align="left" />
            <el-table-column prop="approvalContent" label="审批内容" align="left" />
            <el-table-column prop="createTime" label="审批时间" align="left" />
            <el-table-column prop="agree" label="是否同意" align="left">
              <template v-slot="{row}">
                <span>{{ row.agree ? '同意' : '不同意' }}</span>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </el-form>
    </div>

    <span class="footer-btn">
      <el-button @click="handleCancel">取消申请</el-button>
      <el-button type="primary" @click="handleSubmit">提交申请</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { MathAdd, downloadBlobFile } from '@/libs/util';
import { uploadAdvance, getCustomerBankInfo, exportProductInfo } from '@/API';
export default {
  props: {
    fromInfo: {
      type: Object,
      default: () => {}
    },
    // 什么类型的视图（编辑/详情）
    viewType: {
      type: String,
      default: ''
    },
    isNum: {
      type: Boolean,
      default: true
    }
  },

  computed: {
    titleText () {
      if (this.isNum) return `开票通知单（${this.fromInfo.approvalNumber ?? ''}）`;
      return '开票通知单';
    }
  },

  data () {
    return {
      isShow: false,
      fileList: [],
      filesTypeList: ['xls', 'xlsx'],
      kpOrderUnitList: [],
      invoiceTypeData: [
        { label: '增值税普通发票', value: 1 },
        { label: '增值税电子普通发票', value: 2 },
        { label: '增值税专用发票', value: 3 },
        { label: '出口发票', value: 4 }
      ],
      invoiceMarkData: [
        { label: '蓝字发票', value: 1 },
        { label: '红字发票', value: 2 }
      ]
    };
  },

  methods: {
    openDialog () {
      this.isShow = true;
    },

    // 开票客户名称
    handeleInput (e) {
      this.$emit('handele-input', e);
    },

    // 附件删除
    handleRemove () {
      this.$emit('handle-remove');
    },

    // 提交
    handleSubmit () {
      this.$emit('handle-submit');
    },

    // 取消提交
    handleCancel () {
      this.isShow = false;
      this.kpOrderUnitList = [];
      this.$emit('handle-cancel');
    },

    handleChange (val) {
      this.$emit('chang-client', val, this.kpOrderUnitList);
    },

    handleTotal (params) {
      const { columns } = params;
      const tempTotal = ['合计'];
      columns.forEach((item, index) => {
        if (item.property === 'productNum') { // 数量
          tempTotal[index] = this.allAmount('productNum');
        } else if (item.property === 'settlementAmount') { // 实际结算金额
          tempTotal[index] = this.allAmount('settlementAmount');
        } else if (item.property === 'amountExcludingTax') { // 不含税金额
          tempTotal[index] = this.allAmount('amountExcludingTax');
        } else if (item.property === 'taxAmount') { // 税额
          tempTotal[index] = this.allAmount('taxAmount');
        }
      });
      return tempTotal;
    },

    allAmount (type) {
      let cont = 0;
      (this.fromInfo.productList || []).forEach((item) => {
        cont = MathAdd(cont, item[type]);
      });
      cont = Number(cont).toFixed(2);
      return cont;
    },

    // 客户名称远程搜索
    getSelectClient (val) {
      getCustomerBankInfo({
        kpOrderUnit: val
      }).then(res => {
        const { data, status } = res.data;
        if (status === '200') {
          this.kpOrderUnitList = data || [];
        } else {
          // 参数为空处理
          this.kpOrderUnitList = [];
          this.$emit('chang-client', val, this.kpOrderUnitList);
        }
      });
    },

    handleProgress (file) {
      const { name } = file;
      let fileType = name.slice(name.lastIndexOf('.') + 1);
      if (this.filesTypeList.indexOf(fileType) === -1) {
        this.$message.error(`只支持 ${this.filesTypeList.join(',')} 的文件类型`);
      }
      return this.filesTypeList.indexOf(fileType) !== -1;
    },

    uploadaction (upload) {
      const isLt0M = upload.file.size > 31457280;
      if (isLt0M) {
        this.$message.error('上传文件大小不能大于30M!');
        return false;
      }
      const form = new FormData(); // 创建form对象
      form.append('file', upload.file);
      uploadAdvance(form).then(res => {
        const { data } = res;
        if (data.status === '200') {
          this.$message.success(`文件“${upload.file.name}”,上传成功.`);
          this.fromInfo.fileListTemp = [{
            name: data.data.fileName,
            fileToken: data.data.fileToken
          }];
        }
      });
    },

    handleExportProductInfo () {
      let params = {
        productList: this.fromInfo.productList || [],
        kpOrderUnit: this.fromInfo.bankInfo.kpOrderUnit || '',
        kpTaxpayerNum: this.fromInfo.bankInfo.kpTaxpayerNum || '',
        taxRegistrationAddress: this.fromInfo.bankInfo.taxRegistrationAddress || '',
        taxRegistrationTelephone: this.fromInfo.bankInfo.taxRegistrationTelephone || '',
        bankDeposit: this.fromInfo.bankInfo.bankDeposit || '',
        bankAccount: this.fromInfo.bankInfo.bankAccount || ''
      };
      exportProductInfo(params).then((res) => {
        console.log(res);
        downloadBlobFile({
          content: res.data,
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
          fileName: '商品明细'
        });
      });
    }
  }
};
</script>

<style>
.flex-none {
  display: -webkit-box;
}
.file-style {
  display: flex;
  justify-content: space-between;
}
.info-list{
  margin-top: 20px;
}
.footer-btn {
  display: block;
  margin-top: 15px;
  text-align: right;
}
.file-item {
  display: flex;
}
.down-file-style {
  margin-top: 8px;
}
</style>
